import React, { useEffect, useState } from 'react'
import LeftControl from '../../Components/LeftControl'
import { Button, Divider, Form, Input, message, Modal, Radio, Spin } from 'antd'
import { Grid } from '@material-ui/core'
import PageHeader from '../../Components/PageHeader'
import { useHistory, useLocation } from 'react-router-dom'
import { ErrorMessages, checkStatus, showText } from '../../helpers/textValidation'
import { createLocomotive, getAllLocomotiveLease, getEquipmentLookupWordOrders, getLocomotiveByID, updateLocomotive } from '../../Services/LocomotiveServices'
import { CaretLeftOutlined, ConsoleSqlOutlined, ContactsOutlined, EditOutlined, FileTextOutlined, LoadingOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import LocmotiveLookupModal from '../../Components/Modals/LocmotiveLookupModal'
import NotesModal from '../../Components/Modals/NotesModal'
import ContractModal from '../../Components/Modals/ContactsLocomotive'
import LocomotiveLeaseModal from '../../Components/Modals/LocomotiveLeaseModal'
import moment from 'moment'
import roleManager from '../../Components/roles'
import PageLayout from '../../Components/LayoutComponents/PageLayout'
import DynamicTable from '../../Components/TableComponents/DynamicTable'

const EquipmentLookUpEdit = () => {

    const [Data, setData] = useState({})
    const [openModal, setOpenModal] = useState(false)
    const [modalData, setModalData] = useState()
    const [contractModal, setContractModal] = useState(false)
    const [leaseModal, setLeaseModal] = useState(false)
    const [isWOHModalOpen, setIsWOHModalOpen] = useState(false)
    const [wohistoryTableData, setWohistoryTableData] = useState({
        header: [],
        rows: []
    })
    const [woh_loader, setWoh_loader] = useState(false)

    const [edit, setEdit] = useState(false)
    const [form] = Form.useForm()
    const { state, data } = useLocation()
    const [notesModal, setNotesModal] = useState(false)
    const history = useHistory()
    const Fields = [
        {
            name: "Equipment Id",
            key: "EquipUID",
            type: "Text",
            required: true,
            // edit: roleManager("locomotive", "lookupEdit", "equipID") ? true : false
            edit: false
        },
        {
            name: "Model",
            key: "Loco_Model",
            type: "Text",
            required: true
        },
        {
            name: "Horsepower",
            key: "Loco_HP",
            type: "Number",
            required: true
        },
        {
            name: "Powered Axels",
            key: "Axles",
            type: "Number",
            required: true
        },


        {
            name: "Equipment Type",
            key: "Unit_Type",
            type: "Text",
            required: true
        },
        {
            name: "FRA",
            key: "FRA",
            type: "Text",
            required: true,
            edit: false
        },
        {
            name: "Location",
            key: "name",
            type: "Text",
            required: true,
            edit: false
        },

        {
            name: "Status",
            key: "status",
            type: "Text",
            required: true,
            edit: false
        },
        // {
        //     name: "Lease/Financial",
        //     key: "lease",
        //     type: "Text",
        //     required: true,
        //     edit: false
        // },
        // {
        //     name: "Accounting Job",
        //     key: "accounting",
        //     type: "Text",
        //     required: true,
        //     edit: false
        // },
    ]

    const GetLocomotiveByID = async () => {
        const result = await getLocomotiveByID(state.data.id)
        if (result?.httpStatus === 200) {
            form.setFieldsValue({
                ...result?.data,
                ...result?.data?.TGSLocation,
                FRA: result?.data?.FRA,
                accounting: result?.data?.ActJob,
                status: checkStatus(result?.data?.status),
            })
            setData(result?.data)
            getAllLease(result?.data)
        }
    }

    const getAllLease = async (data) => {
        const result = await getAllLocomotiveLease(data?.id)
        if (result.httpStatus === 200) {
            form.setFieldsValue({
                lease: result?.data[0].AutoRenew === 'YES' ? `Expire ${moment(result?.data[0].ContractEndDate).format('MM-DD-YYYY ')}(${result?.data[0].AutoRenew})/Net-$${result?.data[0].MonthlyAmt}` : `Expire ${moment(result?.data[0].ContractEndDate).format('MM-DD-YYYY ')}(${result?.data[0].AgreementType})/Net-$${result?.data[0].MonthlyAmt}`,
            })
        }
    }

    const contractormap = (data) => {
        if (data) {
            let {
                firstName,
                lastName,
                Company
            } = data;

            let output = '';

            if (Company)
                output = Company;

            if (Company && firstName && lastName)
                output = output + "-"

            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName[0]}.`

            return output;
        }

        return ''

    };

    const getWOHistory = async () => {
        setWoh_loader(true)
        let response = await getEquipmentLookupWordOrders(state?.data?.id)
        if (response.httpStatus === 200) setWohistoryTableData({
            header: ['WO ID', "WO Status", "Date Scheduled", 'Repairs Needed', 'Scheduled To', 'WO Description'],
            rows: response?.data?.rows?.map(row => [
                row?.id,
                row?.Status,
                row?.ScheduleDate ? moment(row?.ScheduleDate)?.utc()?.format("MM-DD-YYYY") : "N/A",
                row?.TckId ? row?.Ticket?.TicketCategory?.name : "N/A",
                row?.Assignedto ? `${row?.Assignedto?.firstName} ${row?.Assignedto?.lastName}`
                    : row?.AssignedtoContractor ? contractormap(row?.AssignedtoContractor)
                        : "N/A",
                row?.Description ? row?.Description : "N/A"
            ])
        })
        setWoh_loader(false)
    }

    useEffect(() => {
        GetLocomotiveByID()
    }, [openModal])


    useEffect(() => {
        if (isWOHModalOpen) getWOHistory()
    }, [isWOHModalOpen])


    const HandleModal = (type) => {
        if (type === 'lookup') setOpenModal(!openModal)
        else if (type === 'Notes') {
            setNotesModal(!notesModal)
        }
        else if (type === 'contract') {
            setContractModal(!contractModal)
        } else if (type === 'lease') {
            setLeaseModal(!leaseModal)

        }
    }

    return (
        <PageLayout className="Liq-Container HRPortal EmployeeResult" id='newHireQueuePage'>
            <Grid className="PagesFrame">
                <PageHeader />
                <div style={{
                    alignItems: "center",
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>

                    <Button onClick={() => { history.push({ pathname: "/equipmentlookup", state: { filterData: state?.filteredInfo } }) }}
                        style={{
                            background: 'white',
                            color: "#2863ad",
                            borderRadius: "10px  ",
                            marginTop: "10px"
                        }}>
                        <CaretLeftOutlined /> Back</Button>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Button onClick={() => { history.push({ pathname: "/create-ticket", state: { type: 4, EquipId: Data?.id } }) }}
                            style={{
                                background: '#2863ad',
                                color: "white",
                                borderRadius: "10px",
                                marginTop: "10px"
                            }}>
                            <PlusCircleOutlined /> Open Mechanical Ticket
                        </Button>
                        <Button onClick={() => setIsWOHModalOpen(true)}
                            style={{
                                background: '#2863ad',
                                color: "white",
                                borderRadius: "10px",
                                marginTop: "10px"
                            }}>
                            Work Order History
                        </Button>
                    </div>
                </div>
                <Grid id="PageTitle">Equipment Lookup</Grid>
                <div >
                    <Form style={{ marginTop: '30px', display: "flex", flexDirection: "column", gap: "5px" }}
                        name="LocomotiveForm"
                        onFinish={() => { }}
                        form={form}
                    >
                        {
                            Fields.map((item, index) => (
                                <div style={{ display: "flex", alignItems: "center", }}>
                                    <div style={{
                                        fontWeight: "800",
                                        whiteSpace: "nowrap",
                                        padding: "0px",
                                        margin: "0px",
                                        fontSize: "13px",
                                        display: 'flex',
                                        overflow: 'hidden',
                                        width: '400px',
                                        gap: "10px",
                                        alignItems: "center"
                                    }}>
                                        <p style={{ marginBottom: "0px", width: "130px" }}>{item.name}</p>  {item?.edit && <Button onClick={() => {
                                            if (item?.key !== 'lease') {
                                                setModalData({ label: item, values: Data });
                                                HandleModal('lookup');
                                            } else {
                                                HandleModal('lease');
                                            }
                                        }} style={{ background: "none", border: "none", marginBottom: "0px" }}> <EditOutlined style={{ cursor: "pointer", fontSize: '20px' }} /> </Button>}
                                    </div>
                                    <Form.Item name={item?.key} rules={[{ required: item?.required, message: ErrorMessages.requiredField }]} style={{ display: "flex", alignItems: "center", margin: "0px" }}>
                                        {
                                            <Input type={item?.type} placeholder='N-A' readOnly={true} style={{
                                                background: 'none',
                                                border: "none",
                                                fontSize: "13px",
                                                width: "500px"
                                            }} />
                                        }
                                    </Form.Item>
                                </div>
                            ))
                        }




                        {/* <div style={{ display: "flex", gap: "20px", marginTop: "30px" }}>

                                <Button style={{
                                    background: '#2863ad', color: "white",
                                    width: "fit-content", borderRadius: "10px  "
                                }}><FileTextOutlined />  Data Sheet </Button>

                                <Button onClick={() => { HandleModal('Notes') }} style={{
                                    background: '#2863ad', color: "white",
                                    width: "fit-content", borderRadius: "10px  "
                                }}><PlusOutlined />Notes </Button>


                                <Button onClick={() => { HandleModal('contract') }} style={{
                                    background: '#2863ad', color: "white",
                                    width: "fit-content", borderRadius: "10px  "
                                }}><ContactsOutlined />Contacts </Button>

                            </div> */}
                    </Form>
                </div>
            </Grid>
            <Modal
                open={isWOHModalOpen}
                onCancel={() => setIsWOHModalOpen(false)}
                title="Work Order History"
                footer={null}
                width={1000}
            >
                <Spin
                    spinning={woh_loader || false}
                    indicator={<LoadingOutlined
                        style={{
                            fontSize: 24,
                        }}
                        spin
                    />}>
                    <DynamicTable tableData={wohistoryTableData} Pagination={wohistoryTableData?.rows?.length > 10 ? true : false} />
                </Spin>
            </Modal>
            {/* <LocmotiveLookupModal open={openModal} close={HandleModal} data={modalData} />
            <NotesModal open={notesModal} close={HandleModal} data={Data} />
            <ContractModal open={contractModal} close={HandleModal} data={Data} />
            <LocomotiveLeaseModal open={leaseModal} close={HandleModal} data={Data} /> */}
        </PageLayout>
    )
}

export default EquipmentLookUpEdit